import type { TableRunStatus } from "@Simplicity-Education/core";
import { createContext } from "react";

/**
 * SIM-2729: per-table run facts for the nested table editor, avoiding a prop threaded through all
 * five connector forms. A null context is supported — the column renders empty. `status` is
 * three-state because an absent table means "never written", so a failed fetch with an empty map
 * would report every table as never written, which is the lying-UI defect this removes.
 */
export type TableRunStatusFetchStatus = "loading" | "ready" | "unavailable";

export interface TableRunStatusContextValue {
  /** Keyed by lowercased table name, already filtered to this connector. */
  byTable: Map<string, TableRunStatus>;
  status: TableRunStatusFetchStatus;
  /** Server's own clock at reduce time — ages are measured against this. */
  computedAtMs: number;
  /**
   * SIM-2791: how far back run history was read. Shown verbatim so "no run
   * recorded" states the aperture instead of implying the table never ran.
   * Defaults to 0 for callers that predate it; treat 0 as "unstated".
   */
  lookbackDays: number;
}

export const TableRunStatusContext = createContext<TableRunStatusContextValue | null>(null);
